module.exports = __webpack_public_path__ + "img/loading.9a841042.gif";